<template>
    <div class="mt-4">
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="table-responsive">
                    <table class="table table-striped detail-table">
                        <tbody>
                        <tr v-for="(row, index) in filtered_doctor" :key="index">
                            <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                            <td>{{row}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import TableDataExcluder from '@/mixins/table-data-excluder';

  export default {
    props: {
      doctor: {
        type: Object
      }
    },
    mixins: [TableDataExcluder],
    data() {
      return {
        excludedFields: ['id','user_id']
      }
    },
    computed: {
      filtered_doctor() {
        return this.excluder(this.doctor, this.excludedFields);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Detail/Tabs/DoctorTab.vue